import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin: 10px 0;
  column-gap: 16px;
`;

export const Footer = styled.div`
  font-weight: 300;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-top: 24px;
`;
